// test686
(686 && 0);
